"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTO_REFI_URL = exports.HOME_EQUITY_URL = void 0;
const HOME_EQUITY_URL = `${process.env.CWA_DOMAIN_NAME}/home-equity/solicitacao/informacoes-pessoais`;
exports.HOME_EQUITY_URL = HOME_EQUITY_URL;
const AUTO_REFI_URL = `${process.env.CWA_DOMAIN_NAME}/auto-refi`;
exports.AUTO_REFI_URL = AUTO_REFI_URL;